import axios from "axios";

const LogInUser = (obj) => {
  return axios.post("users/signin", obj);
};
const RegisterUser = (obj) => {
  return axios.post("users/signup", obj);
};
const RequestUser = (obj) => {
  return axios.post("users/addPublisherRequest", obj);
};
const EditUser = (auth, obj) => {
  console.log(obj);
  return axios.put("users/edit", obj, {
    headers: {
      "Content-Type": "multipart/form-data",
      "x-auth-token": auth,
    },
  });
};
const ResetPassword = (auth, obj) => {
  return axios.put("users/reset-pass", obj, {
    headers: {
      "x-auth-token": auth,
    },
  });
};
const GetPublihserName = (id) => {
  return axios.get(`users/publisher/${id}`);
};

export {
  LogInUser,
  RegisterUser,
  EditUser,
  GetPublihserName,
  RequestUser,
  ResetPassword,
};
